import { getEducationCode } from "helpers/hooks/getEducationCode";

export function filterOptionslabels([key, value]: [string, string | number]) {
    switch (key) {
        case "certificationsFilter":
            return getEducationCode(value as string);
        case "maximumHoursFilter":
            return `max. ${value as string} uur`;
        case "minimumHoursFilter":
            return `min. ${value as string} uur`;
        case "zzpHoursFilter":
            return `${value as string} uur`;
        case "distanceFilter":
            if (parseInt(value as string)) {
                return `${value}km`;
            }
            return value;
        default:
            return value;
    }
}
